import Tile from "./Tile";

export default function TechAreaForm({
  techRoles,
  jobRoleDetails,
  onSelectTechRole
}) {
  return (
    <div className="row">
      {techRoles.map((techRole) => (
        <Tile
          item={techRole}
          onSelect={onSelectTechRole}
          jobRoleDetails={jobRoleDetails}
          field="techRoleId"
        />
      ))}
    </div>
  );
}
